export default __webpack_public_path__ + "static/B0136-28932842a49a25e42c6b9b236f74c540.png";